import { FieldModel } from '../extraction-models';
import { Validations } from '@ps-gui/ui';
import { FieldType } from '@ps-gui/shared-utils';

export const Diagnosen = {
  diagnosen_icd10_code: {
    key: 'diagnosen_icd10_code',
    label: { text: 'ICD-10 Code', genus: 'M' },
    type: FieldType.STRING,
    customTransformValue: (value) => transformIcd10(value),
    index: 0,
    widthUtilityClass: 'w-4/12',
    validators: [Validations.required(), Validations.maxLength(10)],
  },
  diagnosen_lokalisation: {
    key: 'diagnosen_lokalisation',
    label: { text: 'Lokalisation', genus: 'F' },
    type: FieldType.STRING,
    index: 1,
    widthUtilityClass: 'w-8/12',
    validators: [],
  },
  diagnosen_lokalisation_consolidation: {
    key: 'diagnosen_lokalisation_consolidation',
    inlineConsolidatorForField: 'diagnosen_lokalisation',
    inlineConsolidatorRequired: false,
    label: { text: 'Lokalisation Konsolidierung', genus: 'F' },
    type: FieldType.DROPDOWN,
    options: ['L', 'R', 'B'],
    index: 1,
    widthUtilityClass: 'w-8/12',
    validators: [],
  },
} as const satisfies Record<string, FieldModel>;

const transformIcd10 = (rawValue: string): string => {
  let newValue = rawValue;
  if (rawValue.startsWith('1')) {
    newValue = rawValue.replace('1', 'I');
  }
  if (rawValue.startsWith('|')) {
    newValue = rawValue.replace('|', 'I');
  }
  if (rawValue.startsWith('$')) {
    newValue = rawValue.replace('$', 'S');
  }
  if (rawValue.startsWith('5')) {
    newValue = rawValue.replace('5', 'S');
  }
  return newValue
    .replace(/ /g, '')
    .replace(/,/g, '.')
    .replace(/[^a-zA-Z0-9.]/g, '');
};
